import { applyMiddleware, compose, createStore } from 'redux';
import { createBrowserHistory } from 'history';
import { routerMiddleware } from 'connected-react-router';
import createSagaMiddleware from 'redux-saga';
import reducers from './ducks';
import rootSagas from './sagas';

const history = createBrowserHistory();
const routeMiddleware = routerMiddleware(history);

const middlewares = [routeMiddleware];
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const sagaMiddleware = createSagaMiddleware();
middlewares.push(sagaMiddleware);

export default function configureStore() {
  const store = createStore(
    reducers,
    composeEnhancers(applyMiddleware(...middlewares))
  );
  sagaMiddleware.run(rootSagas);
  return store;
}
export { history };
